import { Button } from '@predoc/cow';
import { toast } from 'sonner';

interface CopyButtonProps {
  value: string;
  successMessage?: string;
  children?: React.ReactNode;
}

export const CopyButton = ({
  value,
  successMessage = 'Copied to clipboard',
  children,
}: CopyButtonProps) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    toast.success(successMessage);
  };

  return (
    <Button variant="link" className="h-auto p-0" onClick={handleCopy}>
      {children ?? value}
    </Button>
  );
};
